import { render, staticRenderFns } from "./ListProfissional.vue?vue&type=template&id=520a9e10"
import script from "./ListProfissional.vue?vue&type=script&lang=js"
export * from "./ListProfissional.vue?vue&type=script&lang=js"
import style0 from "./ListProfissional.vue?vue&type=style&index=0&id=520a9e10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports